import trace from "./trace.mjs";

export const mediaQueryState = (() => {

    let _state = 0;
    let _subscriptions = [];

    let _bits = {
        MOBILE    : 1,
        TABLET    : 2,
        DESKTOP   : 4,
        WIDESCREEN: 8,
        FULLHD    : 16,
    };

    let _breakpoints =  'matchMedia' in window ? [
        { name: 'Mobile',     bit: _bits.MOBILE,     mq: window.matchMedia('(max-width:  768px)') },
        { name: 'Tablet',     bit: _bits.TABLET,     mq: window.matchMedia('(min-width:  769px)') },
        { name: 'Desktop',    bit: _bits.DESKTOP,    mq: window.matchMedia('(min-width: 1024px)') },
        { name: 'Widescreen', bit: _bits.WIDESCREEN, mq: window.matchMedia('(min-width: 1216px)') },
        { name: 'Full HD',    bit: _bits.FULLHD,     mq: window.matchMedia('(min-width: 1564px)') }
    ] : [] ;

    /**
     * Add or remove a bit from the state
     *
     * @param {Number}  bit     Bitwise integer to add/remove from state
     * @param {Boolean} matches True to add the state bit, false to remove it
     * @private
     */
    let _updateState = ( bit, matches ) => {
        _state = matches ? _state | bit : _state & ~bit ;
    };

    let _notifySubscribers = () => {
        _state && _subscriptions.map( s => s(public_interface) );
    };

    let _is  = value => ( value & _state ) === value ;
    let _not = value => ( value & _state ) === 0 ;

    for( let breakpoint of _breakpoints ) {
        breakpoint.mq.addEventListener( 'change', e => {
            trace.info( `Media query: rule '${breakpoint.name}' ` + (e.matches ? 'active' : 'disabled') );

            _updateState( breakpoint.bit, e.matches );
            _notifySubscribers();
        });

        _updateState( breakpoint.bit, breakpoint.mq.matches );
    }

    let public_interface = {
        isMobile         : () => _is(_bits.MOBILE),
        isTablet         : () => _is(_bits.TABLET),
        isTouch          : () => _is(_bits.MOBILE) || _is(_bits.TABLET),
        isDesktop        : () => _is(_bits.DESKTOP),
        isDesktopOnly    : () => _is(_bits.DESKTOP) && _not(_bits.WIDESCREEN),
        isWidesreen      : () => _is(_bits.WIDESCREEN),
        isWidescreenOnly : () => _is(_bits.WIDESCREEN) && _not(_bits.FULLHD),
        isFullHD         : () => _is(_bits.FULLHD),
        getState         : () => _state,
        getDescription   : () => {
            if( _is(_bits.FULLHD) )
                return 'Full HD';
            if( _is(_bits.WIDESCREEN) )
                return 'Widescreen';
            if( _is(_bits.DESKTOP) )
                return 'Desktop';
            if( _is(_bits.TABLET) )
                return 'Tablet';
            if( _is(_bits.MOBILE) )
                return 'Mobile';

            return 'Unknown';
        },
        subscribe        : callback => {
            _subscriptions.push(callback);
            callback( public_interface );
            return {
                unsubscribe : () => {
                    _subscriptions = _subscriptions.filter( x => x !== callback );
                }
            }
        },

    };

    return public_interface;

})();
